import { useMemo, useReducer } from "react";
import {
  CategoryStandardProduct,
  StandardProductCategory,
} from "shared/api/middleware-api-client";

export interface StandardProductReducerState {
  selectedStandardProductCategory: StandardProductCategory | undefined;
  selectedStandardProduct: CategoryStandardProduct | undefined;
  standardProductCategories: StandardProductCategory[];
}

export type StandardProductReducerActions = {
  selectStandardProduct: (
    standardProduct: CategoryStandardProduct | undefined
  ) => void;
  selectStandardProductCategory: (
    category: StandardProductCategory | undefined
  ) => void;
  setStandardProductCategories: (categories: StandardProductCategory[]) => void;
};

enum ReducerTypes {
  SELECT_STANDARD_PRODUCT_CATEGORY,
  SELECT_STANDARD_PRODUCT,
  SET_STANDARD_PRODUCT_CATEGORIES,
}
interface Action {
  type: ReducerTypes;
  data: any;
}
function reducer(
  state: StandardProductReducerState,
  action: Action
): StandardProductReducerState {
  switch (action.type) {
    case ReducerTypes.SELECT_STANDARD_PRODUCT:
      return { ...state, selectedStandardProduct: action.data };
    case ReducerTypes.SELECT_STANDARD_PRODUCT_CATEGORY:
      return { ...state, selectedStandardProductCategory: action.data };
    case ReducerTypes.SET_STANDARD_PRODUCT_CATEGORIES:
      return { ...state, standardProductCategories: action.data };
    default:
      return state;
  }
}

interface StandardProductReducerValue {
  store: StandardProductReducerState;
  actions: StandardProductReducerActions;
}
export const useStandardProductReducer = (): StandardProductReducerValue => {
  const initialState: StandardProductReducerState = {
    selectedStandardProductCategory: undefined,
    selectedStandardProduct: undefined,
    standardProductCategories: [],
  };
  const [store, dispatch] = useReducer(reducer, initialState);

  const actions: StandardProductReducerActions = useMemo(
    () => ({
      selectStandardProduct: (
        standardProduct: CategoryStandardProduct | undefined
      ) =>
        dispatch({
          type: ReducerTypes.SELECT_STANDARD_PRODUCT,
          data: standardProduct,
        }),
      selectStandardProductCategory: (
        category: StandardProductCategory | undefined
      ) =>
        dispatch({
          type: ReducerTypes.SELECT_STANDARD_PRODUCT_CATEGORY,
          data: category,
        }),
      setStandardProductCategories: (categories: StandardProductCategory[]) =>
        dispatch({
          type: ReducerTypes.SET_STANDARD_PRODUCT_CATEGORIES,
          data: categories,
        }),
    }),
    []
  );

  const returnValue = useMemo(() => ({ store, actions }), [store, actions]);
  return returnValue;
};
